import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/lib/AuthContext';
import { CartProvider } from '@/lib/CartContext';
import { Toaster } from '@/components/ui/sonner';
import { RouteSeo } from '@/components/Seo';

import LoginPage from '@/pages/LoginPage';
import AuthCallback from '@/pages/AuthCallback';
import HomePage from '@/pages/HomePage';
import GoldPage from '@/pages/GoldPage';
import SilverPage from '@/pages/SilverPage';
import CollectibleDetailPage from '@/pages/CollectibleDetailPage';
import DropCalendarPage from '@/pages/DropCalendarPage';
import DropDetailPage from '@/pages/DropDetailPage';
import PortfolioPage from '@/pages/PortfolioPage';
import MetalRatesPage from '@/pages/MetalRatesPage';
import EducationPage from '@/pages/EducationPage';
import EducationDetailPage from '@/pages/EducationDetailPage';
import OrdersPage from '@/pages/OrdersPage';
import CertificatePage from '@/pages/CertificatePage';
import VerifyPage from '@/pages/VerifyPage';
import FAQPage from '@/pages/FAQPage';
import AdminPage from '@/pages/AdminPage';
import PurityStandardsPage from '@/pages/PurityStandardsPage';
import ChestPage from '@/pages/ChestPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import ReturnsPage from '@/pages/ReturnsPage';
import CustomRequestPage from '@/pages/CustomRequestPage';
import WishlistPage from '@/pages/WishlistPage';
import SearchPage from '@/pages/SearchPage';
import OrderSuccessPage from '@/pages/OrderSuccessPage';
import PothdarPage from '@/pages/PothdarPage';

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment for session_id synchronously during render
  // This prevents race conditions with AuthProvider's useEffect
  if (location.hash?.includes('session_id=')) {
    return <><RouteSeo /><AuthCallback /></>;
  }

  return (
    <>
    <RouteSeo />
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/gold" element={<GoldPage />} />
      <Route path="/silver" element={<SilverPage />} />
      <Route path="/collectible/:id" element={<CollectibleDetailPage />} />
      <Route path="/calendar" element={<DropCalendarPage />} />
      <Route path="/drops/:id" element={<DropDetailPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/rates" element={<MetalRatesPage />} />
      <Route path="/learn" element={<EducationPage />} />
      <Route path="/learn/:id" element={<EducationDetailPage />} />
      <Route path="/orders" element={<OrdersPage />} />
      <Route path="/order-success/:orderId" element={<OrderSuccessPage />} />
      <Route path="/certificate/:id" element={<CertificatePage />} />
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/pothdar" element={<PothdarPage />} />
      <Route path="/purity-standards" element={<PurityStandardsPage />} />
      <Route path="/chest" element={<ChestPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/returns" element={<ReturnsPage />} />
      <Route path="/custom" element={<CustomRequestPage />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="/search" element={<SearchPage />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRouter />
          <Toaster
            position="top-right"
            toastOptions={{
              style: { background: '#121212', border: '1px solid rgba(255,255,255,0.08)', color: '#ededed', borderRadius: '12px' },
            }}
          />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
